<template>
  <footer>
    <div style="position: fixed;bottom: 0;z-index: 9999;text-align: center;color: white!important;width: 100%;">
      <div style="width: 1024px;margin: 0 auto;">
        <p>
<!--          <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=" target="_blank">粤公网安备 XXXXXXXXXXX号</a>-->
          <span style="margin: 0 10px;">
            <a href="https://beian.miit.gov.cn/" style="color: white!important;" target="_blank"> 粤ICP备2023133949号 </a>
          </span>
          ©2023 供应链企业信用管理平台
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "HomeFooter"
}
</script>

<style scoped>

</style>
